import { client } from "../../../api/axiosConfig";

export const createCheckoutSession = (data) => {
  return client.post("/create-checkout-session", data);
};

export const getPaymentStatus = (userId) => {
  return client.get(`/get-payment-status/${userId}`);
};

// data: { userId, licenseKey }
export const verifyLicenseKey = (data) => {
  return client.post("/verify-license-key", data);
};


export const requestPlanActivation = (data) => {
  return client.post(`/request-plan`, data)
}